<template>
  <validation-observer ref="requestFilterRef" tag="form">
    <div class="rounded bg-gray-1 px-3 py-4">
      <div class="row">
        <div class="col-12 col-md-4">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-input
              v-model="model.requestNumber"
              custom-error-msg="El número de solicitud es requerido."
              :error="errors[0]"
              icon="fas fa-search color-primary-2"
              left-icon
              placeholder="Escriba Número de Solicitud o SIE"
              type="text"
            />
          </validation-provider>
        </div>
        <div class="col-12 col-md-2">
          <custom-drop-down
            v-model="model.type"
            fieldkey="id"
            fieldname="name"
            :options="listOptions"
            placeholder="Seleccione"
            @input="onChangeAcademicYear"
          />
        </div>
        <div class="col-12 col-md-5 mt-2 mt-md-0">
          <action-button
            i="fa fa-search orange-icon"
            text="Buscar"
            variant="success px-4"
            @click="onSearch()"
          />
        </div>
      </div>
    </div>
  </validation-observer>
</template>

<script>
//libs components
import CustomInput from 'CustomInput';
import ActionButton from 'ActionButton';
import CustomDropDown from 'custom-drop-down';
//utils
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';

export default {
  name: 'SearchRequestFilter',
  mixins: [alertMixin],
  components: {
    CustomInput,
    ActionButton,
    CustomDropDown,
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler(value) {
        this.model = value;
      },
    },
    model: {
      deep: true,
      immediate: true,
      handler(value) {
        this.$emit('input', value);
      },
    },
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    model: {
      requestNumber: null,
      type: null,
    },
    listOptions: [
      {
        id: 0,
        name: 'Todos',
      },
      {
        id: 1,
        name: 'Disponibles',
      },
      {
        id: 2,
        name: 'No disponible',
      },
    ],
  }),
  methods: {
    async onSearch() {
      const isValid = await this.$refs.requestFilterRef.validate();
      if (!isValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        );
        return;
      }
      this.$emit('on-search', this.model);
    },
  },
};
</script>
